import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="credit-card-detector"
export default class extends Controller {
    static targets = ["numberInput", "cardTypeRadio", "cardTypeImage"]

    connect() {
        console.log('Credit Card Detector controller connected');
        // Initialize on page load
        this.detectCardType();
    }

    /**
     * Called when the credit card number input changes
     */
    numberChanged() {
        this.detectCardType();
    }

    /**
     * Determine the credit card type based on the card number
     */
    determineCardType(ccNumber) {
        if (!ccNumber) return null;

        const firstChar = ccNumber.charAt(0);
        const secondChar = ccNumber.charAt(1);

        switch (firstChar) {
            case '3':
                if (secondChar === '6') return 'master'; // Maestro/Diners
                return 'american_express';
            case '4':
                return 'visa';
            case '5':
                return 'master';
            case '6':
                return 'discover';
            default:
                return null;
        }
    }

    /**
     * Detect card type and update UI
     */
    detectCardType() {
        if (!this.hasNumberInputTarget) return;

        // Get the credit card number and remove spaces
        const ccNumber = this.numberInputTarget.value.replace(/\s/g, '');

        // Determine the type of credit card
        const ccType = this.determineCardType(ccNumber);

        // Reset all card images to full opacity
        this.cardTypeImageTargets.forEach(img => {
            img.style.opacity = '1';
            img.style.filter = 'alpha(opacity=100)';
            // Remove any selected state styling
            img.parentElement.classList.remove('selected');
        });

        // If there's a determined card type, select it and dim other images
        if (ccType) {
            // Find and check the corresponding radio button
            const matchingRadio = this.cardTypeRadioTargets.find(radio => radio.value === ccType);
            if (matchingRadio) {
                matchingRadio.checked = true;
                // Add selected state to the parent label
                matchingRadio.parentElement.classList.add('selected');
            }

            // Dim all non-matching card images
            this.cardTypeImageTargets.forEach(img => {
                const radio = img.parentElement.querySelector('input[type="radio"]');
                if (radio && radio.value !== ccType) {
                    img.style.opacity = '0.3';
                    img.style.filter = 'alpha(opacity=30)';
                }
            });
        }
    }
}
